var map = {
	"./NYU-Logo.png": 93,
	"./address_image.svg": 94,
	"./animated_ashutosh.png": 95,
	"./animated_logo.svg": 96,
	"./blogs_image.svg": 97,
	"./cloud_infrastructure.svg": 98,
	"./codeInLogo.png": 99,
	"./contactMail.png": 100,
	"./coursera_logo.png": 101,
	"./data_science.svg": 102,
	"./deeplearning_ai_logo.png": 103,
	"./delhivery_logo.png": 104,
	"./developerActivity.svg": 105,
	"./dsc_logo.png": 106,
	"./education.svg": 107,
	"./experience.svg": 108,
	"./feelingProud.svg": 109,
	"./freecopy_logo.png": 110,
	"./fullstack.svg": 111,
	"./gcp_logo.png": 112,
	"./github_logo.png": 113,
	"./googleAssistant.jpg": 114,
	"./googleAssistant.svg": 115,
	"./google_logo.png": 116,
	"./ibm_logo.png": 117,
	"./iiitk_logo.png": 118,
	"./intel_logo.jpg": 119,
	"./iu_logo.png": 120,
	"./jsFramework.svg": 121,
	"./legato_logo.png": 122,
	"./manOnTable.svg": 123,
	"./microsoft_logo.png": 124,
	"./mozilla_logo.png": 125,
	"./muffito_logo.png": 126,
	"./nextuLogo.jpg": 127,
	"./nptel_logo.png": 128,
	"./portfolio.gif": 129,
	"./programmer.svg": 130,
	"./projects_image.svg": 131,
	"./pwa.png": 132,
	"./saayaHealthLogo.png": 133,
	"./stanford_logo.png": 134,
	"./talksCardBack.svg": 135,
	"./talksCardBackAlt.svg": 136,
	"./tiktok_logo.png": 137,
	"./ui_ux_design.svg": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;